import { useMutation } from "react-query";
import { addSafeType } from "../../../../../actions/Utilities/SafeType";
import { toast } from "components/toastNotification";
import { ISafeType } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateSafeType, safeTypeReFetching } from "../atoms/atoms";

const useAddSafeType = () => {
  const setIsAddState = useSetRecoilState(addStateSafeType);
  const [isReFetching, setIsReFetching] = useRecoilState(safeTypeReFetching);

  const { mutate } = useMutation((NewData: ISafeType) => addSafeType(NewData), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Adding Safe Type failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Safe Type Added Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Safe Type Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Adding Safe Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Safe Type failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Adding Safe Type failed", res, "error");
        }
      }

      // Redirect to View
      setIsAddState(false);

      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },

    onError: (error: any) => {
      toast.fire("Add Safe Type failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
};
export default useAddSafeType;
